import { Select, Layout, EmptyState } from '@iba-team/portal-react-components/dist';
import React, { useEffect, useState } from 'react';
import { currentYear, yearsTuple } from '../../myLeaves/MyLeaves';
import './analyticsStyles.scss';
import { AbsenceItem } from '../AbsenceItem';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { AnalyticsStore } from '../../../store/Analytics';
import { ProfileComponentsParams } from '../Profile';
import NoLeaves from '../../../assets/no-scheduled-leaves.png';
import { UserStore } from '../../../store/User';

const pool = [
  {
    type: 'Military Leave',
    color: '#216B2B',
  },
  {
    type: 'Vacation',
    color: '#90D886',
  },
  {
    type: 'Vacation (On Demand)',
    color: ' #60B15D',
  },
  {
    type: 'Sick Leave',
    color: '#E46A5F',
  },
  {
    type: 'Compensatory Off',
    color: '#71BEF1',
  },
  {
    type: 'Occasional Leave',
    color: '#FAA53D',
  },
  {
    type: 'Force Majeure',
    color: '#D32F2F',
  },
  {
    type: 'Unpaid Leave',
    color: '#D0D7DE',
  },
  {
    type: 'Unpaid Care Leave',
    color: '#AFB8C1',
  },
  {
    type: 'Unpaid Maternity Leave',
    color: '#8BDBE5'
  },
  {
    type: 'Paternity Leave',
    color: '#8250DF',
  },
  {
    type: 'Parental Leave',
    color: '#C297FF',
  },
  {
    type: 'Unpaid Parental Leave',
    color: '#ECD8FF',
  },
  {
    type: 'Unexcused Absence',
    color: '#42D0FF',
  },
  {
    type: 'Childcare Sick Leave',
    color: '#F19481',
  },
  {
    type: 'Childcare Extra Leave',
    color: '#D97008',
  },
  {
    type: 'Maternity Leave',
    color: '#37B4C3'
  }
];

export const Analytics = observer(({userId, className}: ProfileComponentsParams) => {
  const [year,setYear] = useState(currentYear);
  const {analyticsList, fetchAnalytics, isFetchedAnalytics}= AnalyticsStore;
  const {profile} = UserStore;
  const convertToArray = analyticsList.statistics.map((item) => {
    const [name, value] = Object.entries(item)[0];
    const getColor = pool.find(elem => elem.type === name )?.color;
    return {value: value,
      color:getColor,
      type: name };
  });

  useEffect(()=>{
    fetchAnalytics(year, userId);
  },[year, userId]);

  const { t } = useTranslation();

  return (
    <Layout className={`analytics ${className}`} isLoading={!isFetchedAnalytics} header={{layoutName: <h3>
      {t('absenceAnalytics')}
    </h3>, right: <Select value={year}
      onChangeValue={value=> setYear(value)}
      render={(item)=> <div>{item}</div>}
      list={yearsTuple}
      uniqueElement={el => el === year}
    />}}>
      {analyticsList.totalDaysCount ?
        <>
          <div className={'progress_bar'}>
            <div className={'progress_bar_title'}>
              <div>
                {t('totalAbsences')}
              </div>
              <div>
                {analyticsList.totalDaysCount}
              </div>
            </div>
            <div className={'progress_bar_line'}>
              {convertToArray.map((item)=>
                <div className={`${convertToArray.length === 1 && 'progress_single'} progress_bar_item`}
                  style={{background: item.color, width: `${item.value * 100 / analyticsList.totalDaysCount}%`}}
                />
              )}
            </div>
          </div>
          <div className={'absence_stats'}>
            {convertToArray.map((item)=>
              <AbsenceItem text={item.type} balance={item.value} badgeColor={item.color ?? 'blue'}/>
            )}
          </div>
        </>
        :
        <EmptyState className={'noAbsences'} icon={<img src={ NoLeaves } className="img" alt={'noAbsences'}/>} title={t('noAbsences')} description={t(!userId || +userId === profile.id? 'noAbsencesDescription' : 'noHrAbsencesDescription')}/>
      }
    </Layout>
  );
});
